
import { useState, useEffect } from 'react';
import { LeaderboardItem } from '../types';
import { RevenueDataModel, ValidationError } from '../data-model';

/**
 * Hook for managing the revenue data model
 */
export function useRevenueDataModel(leaderboardData: LeaderboardItem[]) {
  const [dataModel, setDataModel] = useState<RevenueDataModel | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [validationErrors, setValidationErrors] = useState<ValidationError[]>([]);
  
  useEffect(() => {
    if (leaderboardData.length > 0) {
      const model = new RevenueDataModel().initialize(leaderboardData);
      setDataModel(model);
      setValidationErrors(model.getValidationErrors());
      setIsInitialized(true);
    }
  }, [leaderboardData]);
  
  return {
    dataModel,
    isInitialized,
    validationErrors,
    hasErrors: validationErrors.length > 0
  };
}
